<template>
  <vl-properties-list>
    <vl-properties-label>{{ $t('productprocessdefinition.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('productprocessdefinition.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('productprocessdefinition.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ detail.description }}</vl-properties-data>
    <vl-properties-label>{{ $t('productprocessdefinition.detail.organisation') }}</vl-properties-label>
    <vl-properties-data>{{ detail.organisation }} ({{ detail.ovoNumber }})</vl-properties-data>
    <vl-properties-label>{{ $t('productprocessdefinition.detail.deliveryprocessdefinition') }}</vl-properties-label>
    <vl-properties-data v-if="detail.deliveryProcessDefinition">
      <PbsEntityRouterLink type="deliveryProcessDefinition" :detail="detail.deliveryProcessDefinition" />
    </vl-properties-data>
    <vl-properties-data v-else>/</vl-properties-data>
    <vl-properties-label>{{ $t('entitymodel.detail.status') }}</vl-properties-label>
    <vl-properties-data>{{ getStatusLabel(detail.statusId) }}</vl-properties-data>
  </vl-properties-list>
</template>

<script lang="ts" setup>
import { ProductProcessDefinitionDetailDto } from '@/api/backoffice/clients';
import { useProductProcessDefinitionDetailStore } from '@/modules/configuration/store/product-process-definition/product-process-definition-detail.store';
import { computed } from 'vue';
import PbsEntityRouterLink from '@/components/PbsEntityRouterLink.vue';
import { ENUM_StatusTypes } from '../../common';

const store = useProductProcessDefinitionDetailStore();

const detail = computed((): ProductProcessDefinitionDetailDto => {
  return store.detail;
});

const getStatusLabel = (statusId: number): string => {
  return Object.values(ENUM_StatusTypes).find((status) => status.id === statusId)?.name ?? '-';
};
</script>

<style lang="scss" scoped>
:deep(.vl-properties__label) {
  flex: 0 0 30%;
}

:deep(.vl-properties__data) {
  flex: 0 0 70%;
}
</style>
